import { useEffect } from 'react';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';

let refGlobal = null;
let lastHeight = 0;
const useResizeEventIframe = (ref) => {
    refGlobal = ref;
    useEffect(() => {
        new ResizeSensor(refGlobal.current, handleResize);
    }, [ref]);

    const handleResize = () => {
        if (window && window.parent) {
            const { clientHeight } = refGlobal.current;
            if (lastHeight !== clientHeight)
                window.parent.postMessage({ height: clientHeight }, '*');
            lastHeight = clientHeight;
        }
    };
};

export default useResizeEventIframe;
